/**
 * FILM logo watermark at the top of specific pages (Partenaires, Rejoindre, Mécénat).
 * Sized to match the footer logo for consistency.
 */
export default function FilmMark() {
  return (
    <div className="px-6 md:px-12 pt-10 pb-4 flex items-center" data-testid="film-mark">
      <img
        src="https://customer-assets-m6fa6gv7.emergentagent.net/job_midi-gallery/artifacts/0zqwmc4d_logo%20Fil%20du%20Midi.png"
        alt="Le Fil du Midi"
        className="h-28 md:h-36 lg:h-40 w-auto object-contain"
        loading="lazy"
      />
    </div>
  );
}
